export default __webpack_public_path__ + "static/media/mobile_main_reward1.5923c84e.png";